import { render, staticRenderFns } from "./PasarLeidosVentaDirecta.vue?vue&type=template&id=9d81978a"
import script from "./PasarLeidosVentaDirecta.vue?vue&type=script&lang=js"
export * from "./PasarLeidosVentaDirecta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports